import { useEffect, useState } from "react";

const useImagesLoading = (deps: unknown[]): boolean => {
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const timeoutId = window.setTimeout(() => {
      if (cancelled) return;

      const check = () => {
        if (cancelled) return;

        const incomplete = Array.from(document.images).filter(
          (img) => !img.complete
        );

        if (incomplete.length === 0) {
          setIsLoading(false);
          return;
        }

        setIsLoading(true);

        Promise.all(
          incomplete.map(
            (img) =>
              new Promise<void>((resolve) => {
                const done = () => resolve();
                img.addEventListener("load", done, { once: true });
                img.addEventListener("error", done, { once: true });
              })
          )
        ).then(() => {
          if (cancelled) return;
          check();
        });
      };

      check();
    }, 100);

    return () => {
      cancelled = true;
      window.clearTimeout(timeoutId);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return isLoading;
};

export default useImagesLoading;
